import React from 'react';
import { URLPRIFIX } from '../../functions/api';

const ListViewUp = ({
  header,
  filteredRecords,
  Tablehead,
  Tablerecord,
  sortConfig,
  handleSort,
  filters,
  onFilterChange,
  store,
  handleOnSelect,
  isSelected,
  handleClickRow,
  handleDelete,
  handleSelectAll,
  isAllSelected,
  tablename,
  currentPage = 1,
  pageSize = 20,
}) => {

  const getStatusTagClass = (status) => {
    // Base classes for all tags to make them rounded and visually appealing
    const baseClasses = "inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap";

    switch (status?.toLowerCase()) {
      case "completed":
        return `${baseClasses} bg-[#f4ecf7] text-[#212f3d]`;
         case "created":
        return `${baseClasses} bg-[#f4ecf7] text-[#212f3d]`; // Light Green background, Dark Green text
      case "billed":
        return `${baseClasses} bg-[#E6F4EA] text-[#188038]`; // Light Purple background, Dark Purple text
      case "inprogress":
        return `${baseClasses} bg-[#f9e79f] text-[#212f3d]`; // Light Yellow background, Dark Yellow text
      case "cancelled":
        return `${baseClasses} bg-[#f8d7da] text-[#721c24]`; // Light Red background, Dark Red text
      case "draft":
        return `${baseClasses} bg-[#d6eaf8] text-[#21618c]`; // Light Blue background, Dark Blue text
      case "waitingforapproval":
        return `${baseClasses} bg-[#ffeeba] text-[#664d03]`; // Light Orange/Yellow background, Darker Orange/Yellow text
           case "awaiting approval":
        return `${baseClasses} bg-[#ffeeba] text-[#664d03]`;
           case "approved":
        return `${baseClasses} bg-[#E6F4EA] text-[#188038]`;
      case "rejected":
        return `${baseClasses} bg-[#ffcccb] text-[#cc0000]`;
         case "hold":
        return `${baseClasses} bg-[#e59866] text-[#212f3d]`; // Light Indigo/Gray background, Darker Indigo text
      default:
        return `${baseClasses} bg-[#e2e3e5] text-[#495057]`; // Light Gray background, Dark Gray text
    }
  };

  // const getStatusTagClass = (status) => {
  //   switch (status) {
  //     case "completed":
  //       return "bg-[#f4ecf7] text-[#212f3d]";
  //     case "billed":
  //       return "bg-[#E6F4EA] text-[#188038]";
  //     case "Paid":
  //       return "bg-[#E6F4EA] text-[#188038]";
  //     case "inprogress":
  //       return "bg-[#f9e79f] text-[#212f3d]";
  //     case "Cancelled":
  //       return "bg-[#ffcccb] text-[#cc0000]";
  //     case "Draft":
  //       return "bg-[#d6eaf8] text-[#21618c]";
  //     default:
  //       return "bg-gray-200"; 
  //   }
  // };

  return (
    <div
      className={`flex  overflow-auto `}
      style={{ height: '90%', width: '100%' }}
    >
      {/* <div className="flex  overflow-y-auto overflow-x-hidden w-full h-[90%]"> */}
      <div className="origin-top-left scale-[0.8] min-w-[125%]">
    
        <table className="table-auto w-full h-fit">
          <thead className="sticky top-0 bg-secondary text-left mt-10 border-b">
            <tr className="px-1">
              <th className={Tablehead}>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={isAllSelected}
                  className="w-[12px] h-[18px]"
                />
              </th>
              <th className={Tablehead}>
                S.No.
                <input type="text" className="invisible w-[6px] h-[12px]" readOnly />
              </th>
              {header.map(([name, label], index) => {
                if (label !== "id" && label !== "ACTION" && label !== "select") {
                  return (
                    <th key={index} className={Tablehead}>
                      <div
                        className="flex flex-col cursor-pointer"
                        onClick={() => handleSort(label)}
                      >
                        <div className="flex items-center justify-between">
                          <span>{name}</span>
                          {sortConfig.field === label && (
                            <span>{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                          )}
                        </div>
                        <div className="relative w-full">
                          <input
                            type={label.toLowerCase().includes("date") ? "date" : "text"}
                            //  placeholder={`Filter ${name}`}
                            placeholder='-'
                            className="text-sm w-full"
                            // className=" text-sm w-full"
                            value={filters[label] || ""}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => onFilterChange(label, e.target.value)}
                          />
                        </div>
                      </div>
                    </th>
                  );
                } else if (
                  label === "ACTION" &&
                  (store.getprops("update") || store.getprops("view") || store.getprops("delete"))
                ) {
                  return (
                    <th key={index} className={`${Tablehead} font-bold px-2 py-2`}>
                      <div className="flex flex-col gap-1 w-full">
                        <span className="font-bold">{name}</span>
                        <input type="text" className=" w-[8px] h-[24px]" readOnly />
                      </div>
                    </th>
                  );
                }
                return null;
              })}
            </tr>
          </thead>
          <tbody>
            {filteredRecords.map((item, index) => (
              <tr
                key={item.id || index}
                className={
                  "border-b h-8 hover:bg-[#b3b3f5] rounded-xl cursor-pointer " +
                  (item?.error && ` bg-red bg-opacity-35 `) +
                  (isSelected(item) ? " bg-blue-100 " : "")
                }
              >
                {/* <td
                  className={
                    Tablerecord + " flex justify-center items-center h-full"
                  }
                > */}
                  <td className={`${Tablehead} text-left`}>
                  <input
                    type="checkbox"
                    onChange={(event) => {
                      handleOnSelect(item, event.target.checked);
                    }}
                    checked={isSelected(item)}
                  />
                </td>
                <td className={Tablerecord}>
                  {(currentPage - 1) * pageSize + index + 1}
                </td>

                {header.map(([name, label], fieldindex) => {
                  if (label === "ACTION") {
                    if (store.getprops("update") || store.getprops("delete")) {
                      return (
                        <td key={fieldindex} className={Tablerecord}>
                          <div className="flex gap-7">
                            {store.getprops("update") && (
                              <img
                                src="/Assets/images/pencil.png"
                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                onClick={() => {
                                  store.navTo(
                                    `/${URLPRIFIX}/${tablename}/edit/${item.id}`
                                  );
                                }}
                              />
                            )}
                            {store.getprops("delete") && (
                              <img
                                src="/Assets/images/trash.png"
                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                onClick={() => handleDelete(item)}
                              />
                            )}
                          </div>
                        </td>
                      );
                    }
                  } else if (label === "activeStatus") {
                    return (
                      <td key={fieldindex} className={Tablerecord}>
                        {item[label] ? "Active" : "Inactive"}
                      </td>
                    );
                  }
                  else if (label === "status" || label === "expense_status") {
                    return (
                      <td
                        key={fieldindex}
                        className={Tablerecord}
                        onClick={() => {
                          handleClickRow && handleClickRow(item);
                        }}
                      >
                        <span className={getStatusTagClass(item[label])}>
                          {item[label]}
                        </span>
                      </td>
                    );
                  }
                
                  else if (label.toLowerCase().includes("date")) {
                    const dateValue = item[label];
                    let displayDate = "---";

                    if (typeof dateValue === "string" && dateValue) {
                      const [date] = dateValue.split("T");
                      displayDate = date;
                    }

                    return (
                      <td
                        key={fieldindex}
                        className={Tablerecord}
                        onClick={() => {
                          handleClickRow && handleClickRow(item);
                        }}
                      >
                        {displayDate}
                      </td>
                    );
                  } else if (label !== "id" && label !== "select") {
                    return (
                      <td
                        key={fieldindex}
                        className={Tablerecord}
                        onClick={() => {
                          handleClickRow && handleClickRow(item);
                        }}
                      >
                        {item[label]?.toString()?.charAt(0)?.toUpperCase() +
                          item[label]?.toString()?.slice(1)}
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListViewUp;